var outline = {
  init : function () {
    $(document).ready(function(){
      //通常のクリック時
      $('a[href^="#"]').click(function(e) {
        e.preventDefault();
        //ページ内リンク先を取得
        var href= $(this).attr("href");
        //リンク先が#か空だったらhtmlに
        var hash = href == "#" || href == "" ? 'html' : href;
        //スクロール実行
        scrollToAnker(hash);
        //リンク無効化
      });

      // 関数：スムーススクロール
      // 指定したアンカー(#ID)へアニメーションでスクロール
      function scrollToAnker(hash) {
        var target = $(hash);
        var position = target.offset().top;
        $('body,html').stop().animate({scrollTop:position}, 500);
      }

    })



    var windowWidth = $(window).width();
    var windowSm = 640;
    if (windowWidth <= windowSm) {
      function initialize() {
        var latlng = new google.maps.LatLng(35.176022,136.89711);
        var myOptions = {
          zoom: 15,/*拡大比率*/
          center: latlng,/*表示枠内の中心点*/
          mapTypeControlOptions: { mapTypeIds: ['sample', google.maps.MapTypeId.ROADMAP] }/*表示タイプの指定*/
        };
        var map = new google.maps.Map(document.getElementById('map_canvas'), myOptions);

        /*アイコン設定▼*/
        var icon = new google.maps.MarkerImage('../../corp_assets/img/company/outline/map_icon_sp.png',
          new google.maps.Size(75,34),/*アイコンサイズ設定*/
          new google.maps.Point(0,0)/*アイコン位置設定*/
          );
        var markerOptions = {
          position: latlng,
          map: map,
          icon: icon,
          title: '株式会社アルペン'
        };
        var marker = new google.maps.Marker(markerOptions);
      　/*アイコン設定ここまで▲*/


        var styledMapOptions = { name: '株式会社アルペン' }
        var sampleType = new google.maps.StyledMapType(styleOptions, styledMapOptions);
        map.mapTypes.set('sample', sampleType);
        map.setMapTypeId('sample');
      }
      google.maps.event.addDomListener(window, 'load', initialize);

    } else {
        function initialize() {
          var latlng = new google.maps.LatLng(35.176022,136.89711);
          var myOptions = {
            zoom: 17,/*拡大比率*/
            center: latlng,/*表示枠内の中心点*/
            mapTypeControlOptions: { mapTypeIds: ['sample', google.maps.MapTypeId.ROADMAP] }/*表示タイプの指定*/
          };
          var map = new google.maps.Map(document.getElementById('map_canvas'), myOptions);

          /*アイコン設定▼*/
          var icon = new google.maps.MarkerImage('../../corp_assets/img/company/outline/map_icon.png',
            new google.maps.Size(120,54),/*アイコンサイズ設定*/
            new google.maps.Point(0,0)/*アイコン位置設定*/
            );
          var markerOptions = {
            position: latlng,
            map: map,
            icon: icon,
            title: '株式会社アルペン'
          };
          var marker = new google.maps.Marker(markerOptions);
        　/*アイコン設定ここまで▲*/


          var styledMapOptions = { name: '株式会社アルペン' }
          var sampleType = new google.maps.StyledMapType(styleOptions, styledMapOptions);
          map.mapTypes.set('sample', sampleType);
          map.setMapTypeId('sample');
        }
        google.maps.event.addDomListener(window, 'load', initialize);
    }
  }
}


if($('#p-outline')[0]){
    outline.init();
}
